import React from 'react';
import { ConfirmProvider } from 'material-ui-confirm';
import { createTheme, ThemeProvider } from '@mui/material';
import { deDE } from '@mui/material/locale';
import Router from './Router';
import layoutStore, { LayoutContext } from './stores/LayoutStore';
import Footer from './components/Footer';

const theme = createTheme({
  cssVariables: true,
}, deDE);

function App() {
  return (
    <LayoutContext.Provider value={layoutStore}>
      <ThemeProvider theme={theme}>
        <ConfirmProvider>
          <Router />
          <Footer />
        </ConfirmProvider>
      </ThemeProvider>
    </LayoutContext.Provider>
  );
}

export default App;
